import { CircularProgress, Fade, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { colors, alphaVar } from "../ui/colors";

const GRAY = colors.gray;
const ORANGE = colors.orange;

export const PaginationLoadingOverlay = ({ isVisible }) => (
  <Fade in={isVisible} timeout={{ enter: 200, exit: 300 }}>
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: alphaVar("var(--fx-surface-base, #FFFFFF)", 0.7),
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 2,
      }}
    >
      <Box sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1.5,
        p: 2,
        borderRadius: 1,
        backgroundColor: alphaVar("var(--fx-surface-base, #FFFFFF)", 0.95),
        backdropFilter: "blur(4px)",
        border: `1px solid ${alphaVar(GRAY[200], 0.3)}`,
        boxShadow: `0 2px 12px ${alphaVar("#000", 0.06)}`,
      }}>
        <CircularProgress
          size={28}
          thickness={3.5}
          sx={{
            color: ORANGE.base,
          }}
        />
        <Typography
          variant="caption"
          sx={{
            color: GRAY[600],
            fontWeight: 500,
            fontSize: '0.8rem',
          }}
        >
          Loading...
        </Typography>
      </Box>
    </Box>
  </Fade>
);